<template>
  <div>
    <div class="cgq-list">
      <div :class="`kindlist kindlist${index + 1} ${item.isWater && 'isWater'}`" v-for="(item, index) in relist" :key="item.id">
        <div class="kindtop">
          <div class="kindtop_left fs22">
            <span v-show="item.sensor">{{item.sensor}}-</span>{{ item.name }}
          </div>
          <!-- 右边的设置按钮 -->
          <div class="kindtop_right" @click="setting(item, 0)">
            <img src="../../../assets/images/set.png" />
          </div>
        </div>
        <div class="kindbot">
          <p class="p1 fs22" v-if="item.isWater">
            <!-- <span class="blue">{{ item.value }}</span>
            {{ item.unit }}
            <b v-if="item.otherValue" class="fs14">({{ item.otherValue }})</b> -->

            <WaterPotentialLine :currentValue="item.value" :unit="item.unit" :min="item.lowerLimit" :max="item.uperLimit" />
          </p>
          <!-- 值 -->
          <p class="p1 fs24" v-else>
            <span class="blue">{{ item.value == '#' ? 'null': item.value }}</span>
            <span v-show="item.value != '#'">{{ item.unit }}</span>
            <b v-if="item.otherValue" class="fs14">({{ item.otherValue }})</b>
          </p>
          <!--
             :class="
              item.value >= item.lowerLimit && item.value <= item.uperLimit
                ? 'lv'
                : 'ho'
            "
          -->
          <p class="p2 fs24">
            <span>
              {{ $t('live.waring_text') }}:{{ item.lowerLimit }}~{{
                item.uperLimit
              }}{{ item.unit }}
            </span>
            <span v-if="item.isWater" :class="
                item.value >= item.lowerLimit && item.value <= item.uperLimit
                  ? 'normal'
                  : item.value < item.lowerLimit
                  ? 'enough'
                  : 'error2'
              ">
              {{
                item.value >= item.lowerLimit && item.value <= item.uperLimit
                  ? '适宜'
                  : item.value < item.lowerLimit
                  ? '饱和'
                  : '阀值'
              }}
            </span>
            <span v-else :class="
                item.value >= item.lowerLimit && item.value <= item.uperLimit
                  ? 'normal'
                  : 'error'
              ">
              {{
                item.value >= item.lowerLimit && item.value <= item.uperLimit
                  ? '正常'
                  : '异常'
              }}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- <pageToast ref="pageToastCgq" key="" /> -->
  </div>
</template>

<script>
// 水势组件
import WaterPotentialLine from '@/components/waterPotentialLine'
export default {
  components: {
    WaterPotentialLine,
  },
  props: {
    setting: {
      type: Function,
      default: (item, type) => { },
    },
    callback: {
      type: Function,
      default: (obj) => { },
    },
    hasDeviceChange: {
      type: Boolean,
      default: false,
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    hasDeviceChange (v) {
      console.log("设备切换设备切换设备切换设备切换设备切换");
      if (v) {
        const no = localStorage.getItem('no')
        this.no = no
        this.getCgqList(no)
      }
    },
    refreshing (bl) {
      bl && this.onRefresh()
    },
  },

  computed: {
    placement () {
      return function (index) {
        let i = index + 1
        if (i % 2 === 0) {
          return 'left'
        } else {
          return 'right'
        }
      }
    },
  },

  data () {
    return {
      no: localStorage.getItem('no'),
      isLoading: false,
      relist: [],
      // showPopover: false
    }
  },

  created () {
    const no = localStorage.getItem('no')
    this.no = no
    this.getCgqList(no)
  },

  methods: {
    async getCgqList (no) {
      await this.$toast.loading({
        message: this.$t('common.loading'),
        forbidClick: true,
        duration: 0,
      })

      await this.$api
        .getLiveList({
          no,
          limit: 1,
          startDate: '2020-01-01 00:00:00',
          endDate: this.$setime(new Date(), 1),
        })
        .then((res) => {
          if (res.errcode === 0) {
            if (!this.$isblank(res.list)) {
              const list = res.list
              this.retime = list[0].gatherDate
              this.relist = [...list[0].data]
                .map((item, index) => {
                  return {
                    isWater: item.oriName === '土壤张力',
                    sort: item.oriName === '土壤张力' ? 888 + index : index,
                    ...item,
                    ...this.changeKpaValue(item.value),
                    showPopover: false,
                  }
                })
                .sort((a, b) => a.sort - b.sort)

              // 重新进行排序  选中水势传感器

              this.callback({
                solarVoltage: list[0].solar_voltage,
                voltage: list[0].voltage,
                retime: list[0].gatherDate,
              })
              // this.$refs.pageToast.type = 0;
            } else {
              this.relist = []
              // this.$refs.pageToast.type = 1;
            }
          } else {
            this.relist = []
            // 其他异常
            this.$toast(res.errmsg)
          }
        })
        .catch((err) => {
          this.relist = []
          console.log(err)
          // 其他异常
          this.$toast(this.$t('common.timeout'))
        })
        .finally(() => {
          this.$toast.clear()
        })
    },

    changeKpaValue (v) {
      // "1kpa=1J/kg=0.01Bar=0.001Mpa";
      let p1, p2, p3 = 0, p4 = 0
      p1 = p2 = v
      if (v > 0) {
        p3 = this.pointNum(v, 1)
        p4 = this.pointNum(v, 2)
      } else if (v < 0) {
        p3 = [...v.toString()].splice(2, 0, '00').join('')
        p4 = [...v.toString()].splice(2, 0, '000').join('')
      }
      return {
        p1, p2, p3, p4,
      }
    },

    pointNum (num, type) {
      const arr = [...('0000' + num.toString())]
      const index = arr.indexOf('.')
      // p3 /100  2个0    p4 /1000 3个0
      const mo = type === 1 ? 2 : 3
      if (index > -1) {
        // 有小数点 将小数点前移 2位
        arr.splice(index, 1)
        // +1 是因为上面删除后 长度减1
        arr.splice(index - (mo + 1), 1, '.')
      } else {
        const i = arr.length - 1 - mo
        arr.splice(i, 1, '.')
      }
      return arr.slice(arr.indexOf('.') - 1).join('')
    },

    async onRefresh () {
      this.isLoading = true
      await this.getCgqList(this.no)
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.pull-refresh {
  width: 100%;
}

.cgq-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.isWater {
  width: 100% !important;
}

.kindlist {
  display: inline-block;
  overflow: hidden;
  width: 48%;
  min-height: 1.4rem;
  padding: 0.24rem 0.2rem;
  border-radius: 0.15rem;
  box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.05);
  position: relative;
  background: #fff;
  margin-bottom: 0.2rem;
  box-sizing: border-box;
}

.kindlist .kindtop {
  overflow: hidden;
  line-height: 0.26rem;
}

.kindlist .kindtop .kindtop_left {
  float: left;
  font-size: 13px;
  font-weight: bold;
  color: #333333;
}

.ho {
  background: url(../../../assets/images/red.png) 0 50% no-repeat;
  background-size: 0.22rem 0.22rem;
}

.lv {
  background: url(../../../assets/images/lv.png) 0 50% no-repeat;
  background-size: 0.22rem 0.22rem;
}

.kindlist .kindtop .kindtop_right {
  float: right;
}

.kindlist .kindtop .kindtop_right img {
  width: 14px;
  height: 14px;
}

.kindlist .kindbot {
  text-align: center;
  color: #666;
}

.kindlist .kindbot .p1 span {
  font-size: 24px;
  font-weight: bold;
}

.kindlist .kindbot .p2 {
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding-top: 0.06rem;
  margin-top: 20px;
}

.kindlist .kindbot .p1 {
  position: relative;
  padding-top: 0.2rem;
}

.isWater .p1 {
  padding-top: 1rem !important;
}

.formula {
  display: block;
  font-size: 12px;
  padding: 2px 6px;
}

.formula div {
  line-height: 18px;
}

.kindlist .kindbot .p1 .info {
  position: relative;
  top: -10px;
  font-size: 12px;
  color: rgba(53, 105, 233, 0.9);
}

.kindlist .kindbo {
  position: absolute;
  z-index: -1;
  right: 0;
  bottom: 0;
  width: 1.95rem;
  height: 1.03rem;
  line-height: 1.45rem;
  background: url(../../../assets/images/bo.png) center no-repeat;
  background-size: 100% 100%;
  color: #2855bb;
  text-align: right;
  padding-right: 0.2rem;
}

.kindlist .kindbo.kindbo2 {
  width: 1.98rem;
  line-height: 1.6rem;
  padding-right: 0.12rem;
}

/deep/ .van-popup {
  height: auto;
}

.error {
  display: none;
}

.error2 {
  background: #f56c6c;
  border-radius: 3px;
  color: #ffffff;
  padding: 1px 4px;
}

.normal {
  background: rgba(68, 210, 106, 0.39);
  border-radius: 3px;
  color: #ffffff;
  padding: 1px 4px;
}

.enough {
  background: #409eff;
  border-radius: 3px;
  color: #ffffff;
  padding: 1px 4px;
}
</style>
